<ng-container *ngIf="vm$ | async as vm">
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      ONLINE-BOOK SHIPMENT - SEARCH
      {{ selectedNameAndAddress.displayAddressType | uppercase }}
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body grid-container">
    <form [formGroup]="shipmentPreferredAddressForm">
      <app-shipment-address formControlName="address" [address]="vm.selectedPreferredAddress"
        [isPrimaryAddress]="isPrimaryAddress" [states]="vm.states" [countries]="vm.countries" [showDefaultAddress]="true"></app-shipment-address>
      <div class="grid-row margin-top-2">
        <button [disabled]="isAddressSelected === false" class="usa-button usa-button--secondary" (click)="delete()">
          Delete
        </button>
        <button [disabled]="shipmentPreferredAddressForm.invalid ||  isAddressSelected === false" class="usa-button"
          (click)="modify()">
          Modify
        </button>
        <button [disabled]="shipmentPreferredAddressForm.invalid" class="usa-button" (click)="addToList()">
          Add to List
        </button>
      </div>
    </form>
    <div class="grid-row margin-top-4">
      <ag-grid-angular class="ag-theme-alpine col-md-12" [gridOptions]="shipmentPreferredAddressesGridOptions"
        [rowData]="shipmentPreferredAddresses$ | async">
      </ag-grid-angular>
    </div>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="usa-button usa-button--secondary" (click)="bsModalRef.hide()">
        Close
      </button>
      <button type="button" class="usa-button"
        [disabled]="shipmentPreferredAddressForm.invalid || isAddressSelected === false" (click)="selectAddress()">
        Select Address
      </button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="addShipmentPreferredAddress$ | async"></ng-container>
<ng-container *ngIf="modifyShipmentPreferredAddress$ | async"></ng-container>
<ng-container *ngIf="deleteShipmentPreferredAddress$ | async"></ng-container>
